import React from "react";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
    FilterMultiselectValue,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";

interface TriStateBooleanFilterProps {
    value: boolean | undefined;
    onChange: (value: boolean | undefined) => void;
    trueOption: FilterMultiselectOption;
    falseOption: FilterMultiselectOption;
    name: string;
}

export const TriStateBooleanFilter: React.FC<TriStateBooleanFilterProps> = ({
    value,
    onChange,
    trueOption,
    falseOption,
    name,
}) => {
    const toSelectedValues = (): FilterMultiselectValue[] => {
        if (value === true) {
            return [trueOption.value];
        }
        if (value === false) {
            return [falseOption.value];
        }
        return [];
    };
    const selectedValues = toSelectedValues();

    return (
        <FilterMultiselect
            inDropdown={false}
            options={[trueOption, falseOption]}
            value={selectedValues}
            onChange={(selected) => {
                if (selected.length === 0) {
                    onChange(undefined);
                    return;
                }
                // Single-select: pick the newly added value
                const added = selected.find(
                    (v) =>
                        (v === trueOption.value && value !== true) ||
                        (v === falseOption.value && value !== false),
                );
                if (added === undefined) {
                    // Unreachable: FilterMultiselect always toggles exactly one item,
                    // so `added` is always defined when selection is non-empty.
                    // Guard kept for safety.
                    return;
                }
                if (added === trueOption.value) {
                    onChange(true);
                } else if (added === falseOption.value) {
                    onChange(false);
                }
            }}
            name={name}
            onBlur={noop}
            searchable={false}
        />
    );
};
